// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/sunrise.js';

import { paths } from '../generated/sunrise';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('sunrise', Original, paths);
